import React from 'react';
import { Box, CircularProgress } from '@mui/material';

export default function PageLoader({
  size = 48,
  color = '#5236AB',
  sx,
  'data-testid': dataTestId = 'page-loader',
}) {
  return (
    <Box
      data-testid={dataTestId}
      sx={{
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        ...sx,
      }}
    >
      <CircularProgress size={size} sx={{ color }} aria-label="Loading" />
    </Box>
  );
}
